import { render, staticRenderFns } from "./ConsentBot.vue?vue&type=template&id=6ff71d3c&scoped=true&"
import script from "./ConsentBot.vue?vue&type=script&lang=js&"
export * from "./ConsentBot.vue?vue&type=script&lang=js&"
import style0 from "./ConsentBot.vue?vue&type=style&index=0&id=6ff71d3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff71d3c",
  null
  
)

export default component.exports